import { Integration } from "@/types/Tenant.interface"

interface State {
    integrations: Integration[]
}

const defaults = () => {
    return {
        integrations: []         //  An array of all integrations
    }
}

export default {
    state: defaults(),
    mutations: {
        integrationsPush (state: State, integrations: Integration[]): void {
            state.integrations = window.removeDuplicatesById(state.integrations, integrations)
        },
        integrationsRemove (state: State, id: number): void {
            //  Find the index of our recently removed integration
            const idx = state.integrations.findIndex(x => x.id === id)

            //  If our index is -1 do nothing
            if (idx === -1) return

            //  Else, splice it
            state.integrations.splice(idx, 1)
        },
        integrationsReset (state: State): void {
            Object.assign(state, defaults())
        },
        integrationsSet (state: State, integrations: Integration[]): void {
            state.integrations = integrations
        }
    },
    actions: {
        integrationsDelete ({ commit, getters }, id: number): Promise<void> {
            //  Assemble the API endpoint
            const url = `${getters.api}/integrations/${id}`

            //  Send the request
            return window.axios.delete(url).then(response => {
                //  Remove this integration from our list
                commit('integrationsRemove', id)

                //  Return null since we deleted the integration
                return response.data
            }).catch(() => null)
        },
        integrationsPost ({ commit, getters }, payload: Integration): Promise<Integration> {
            //  Assemble the API endpoint
            const url = `${getters.api}/integrations`

            //  Send the request
            return window.axios.post(url, payload).then(response => {
                //  Add this integration to our list of integrations
                commit('integrationsPush', [response.data])

                //  Return ther created integration
                return response.data
            }).catch(() => null)
        },
        integrationsPut ({ commit, getters }, integration: Integration): Promise<Integration> {
            //  Assemble the API endpoint
            const url = `${getters.api}/integrations`

            //  Send the request
            return window.axios.put(url, integration).then(response => {
                //  Update our integrations list
                commit('integrationsPush', [response.data])

                //  Return the updated integration
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        isSphere (state: State): boolean {
            //  If we have no integrations, return false
            if (!state.integrations) return false

            //  Else, find our sphere integration
            const integration = state.integrations.find((integration) => integration.name === 'sphere')

            //  If this integration exists AND is enabled, return true
            return integration && integration.enabled != 0
        },
        integrations (state: State): Integration[] {
            return state.integrations
        }
    }
}
